import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(0.1),
		'& .MuiTableHead-root': {
			backgroundColor: '#fff',
		},
	},
	paginationContainer: {
		display: 'flex',
		justifyContent: 'center',
	},
	iconCell: {
		width: 73,
	},
	actionCell: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	avatar: {
		'& img': {
			objectFit: 'scale-down',
		},
	},
	itemGroup: {
		...theme.typography.link1,
	},
}));
